// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
async.push(["ready", function() {
    $('.popup-video').magnificPopup({
        disableOn: 0,
        type: 'iframe',
        gallery: {
            enabled: true
        },
        // type: 'ajax',
        mainClass: 'mfp-fade',
        removalDelay: 160,
        preloader: false,

        fixedContentPos: false,
        iframe: {
            markup: '<div class="mfp-iframe-scaler">' +

                '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
                '<div class="mfp-close">Close window</div>' +

                '</div><div class="mfp-author" id="testimonialauthor"></div><div class="mfp-footer"><p> Close window</p></div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

            patterns: {
                youtube: {
                    index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).

                    id: 'v=', // String that splits URL in a two parts, second part should be %id%
                    // Or null - full URL will be returned
                    // Or a function that should return %id%, for example:
                    // id: function(url) { return 'parsed id'; }

                    src: '//www.youtube.com/embed/%id%?autoplay=1&amp;rel=0&amp;showinfo=0' // URL that will be set as a source for iframe.
                }

                // you may add here more sources

            },

            srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
        }
    });

    $('.popup-image').magnificPopup({
        type: 'image',
        gallery: {
            enabled: true
        },
        disableOn: function() {
            if ($(window).width() < 600) {
                return false;
            }
            return true;
        }
    });
}]);